// Stub for ModalDialog — xtracker uses its own DOM modals.
var ModalDialog = function(){
	var me = {};
	me.width = 400;
	me.height = 200;
	me.top = 0;
	me.left = 0;
	me.ok = false;
	me.onDown = function(){};
	me.setText = function(){};
	return me;
};

export default ModalDialog;
